import styled from 'styled-components'
import { contentLevels } from 'sidecar-design-library'

import ListItem from '../ListItem'

export const Overlay = styled.div`
  background: rgba(255, 255, 255, 1);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${contentLevels.components};
  opacity: 0;
  width: 0;
  transition-duration: 200ms;
  transition-property: opacity;

  ${p =>
    p.active &&
    `
    opacity: .75;
    width: 100%;
  `}
`

export const List = styled.div`
  transition: all 200ms;
  position: relative;

  &:not(:last-child) {
    margin-bottom: 1.875rem;
  }

  // TODO: figure out a better way to do this
  // Shouldn't reference components from a different folder
  ${ListItem} {
    // all borders and padding extend the full width.
    ${p =>
      p.fullBleed &&
      `
      margin-left: 0;
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
      &:before, &:after { left: 0; right: 0; }
    `}

    // border extends flush to bothleft and right
    // border extends flush only to left
    // border extends flush only to right
    ${p => p.flush && `&:after, &:before { right: 0; left: 0; }`}
    ${p => p.flushLeft && `&:after, &:before { left: 0; }`}
    ${p => p.flushRight && `&:after, &:before { right: 0; }`}

    // border extends to both left and right on hover
    // border extends only to the left on hover
    // border extends only to the right on hover
    ${p => p.extend && `&:hover { &:after, &:before { left: 0; right: 0; } }`}
    ${p => p.extendLeft && `&:hover { &:after, &:before { left: 0; } }`}
    ${p => p.extendRight && `&:hover { &:after, &:before { right: 0; } }`}

    // hides top border on first child
    // hides bottom border on last child
    // hides borders on first and last child
    ${p => p.noTopBorder && `&:first-child:before { display: none; }`}
    ${p => p.noBottomBorder && `&:last-child:after { display: none; }`}
    ${p =>
      p.noBorder &&
      `
      &:first-child:before { display: none; }
      &:last-child:after { display: none; }
    `}
  }
`
